import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { ICountryOptions } from "interfaces/country";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_COUNTRY_" }
);

export interface ListCountriesState extends IState {
  data: ICountryOptions[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: ICountryOptions[];
}

const INITIAL_STATE: ListCountriesState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListCountriesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListCountriesState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListCountriesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listCountries = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListCountriesTypes = Types;
export const ListCountriesActions = Creators;
